import { Component, Input, OnInit } from '@angular/core';
import { PaymentDueOption, QuoteWorkOrder, SystemSettingGenSvc } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-legal-acceptance-verbiage',
    templateUrl: './legal-acceptance-verbiage.component.html',
    styleUrls: ['./legal-acceptance-verbiage.component.css'],
    standalone: false
})
export class LegalAcceptanceVerbiageComponent implements OnInit {
  @Input() paymentDueOption: PaymentDueOption;

  quote: QuoteWorkOrder
  constructor(private settingsService: SystemSettingGenSvc) { }
  newVerbiage: string;
  @Input() customerType: number;

  ngOnInit() {
   this.getCustomerType();
  }

  getCustomerType(){
    this.settingsService.getNewVerbiage(this.customerType)
    .subscribe(res => this.newVerbiage = res.replace('{{paymentDueOption.paymentDueName}}', this.paymentDueOption.paymentDueName));
  }

}
